import React from 'react'
import styled from 'styled-components'

const PageHeading = styled.h2`
  line-height: 1.176470588;
`

export default PageHeading



// WEBPACK FOOTER //
// ./src/components/PageHeading.js